class ElStatsShowcase {
  constructor(section) {
    this.section = section;
    this.numbers = section.querySelectorAll("[data-el-count-target]");
    this.duration = 1400;
    this.animationFrame = null;

    this.init();
  }

  init() {
    if (!this.numbers.length) return;

    this.resetNumbers();
    this.lockNumberWidths();

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        this.lockNumberWidths();
      });
    }

    window.addEventListener("resize", () => {
      this.lockNumberWidths();
    });

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.play();
          } else {
            this.resetNumbers();
          }
        });
      },
      {
        threshold: 0.35,
      },
    );

    this.observer.observe(this.section);
  }

  play() {
    this.cancelAnimation();
    this.animateNumbers();
  }

  resetNumbers() {
    this.cancelAnimation();

    this.numbers.forEach((number) => {
      const decimals = Number(number.dataset.elCountDecimals || 0);
      const useCommas = number.dataset.elCountCommas === "true";

      number.textContent = this.formatNumber(0, decimals, useCommas);
    });
  }

  lockNumberWidths() {
    this.numbers.forEach((number) => {
      const target = this.parseNumber(number.dataset.elCountTarget || 0);
      const decimals = Number(number.dataset.elCountDecimals || 0);
      const useCommas = number.dataset.elCountCommas === "true";
      const finalText = this.formatNumber(target, decimals, useCommas);
      const currentText = number.textContent;

      number.style.width = "auto";
      number.style.display = "inline-block";
      number.style.textAlign = "right";

      number.textContent = finalText;

      const finalWidth = Math.ceil(number.getBoundingClientRect().width);

      number.style.width = `${finalWidth}px`;
      number.textContent = currentText;
    });
  }

  animateNumbers() {
    const startTime = performance.now();

    const tick = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);

      this.numbers.forEach((number) => {
        const target = this.parseNumber(number.dataset.elCountTarget || 0);
        const decimals = Number(number.dataset.elCountDecimals || 0);
        const useCommas = number.dataset.elCountCommas === "true";
        const value = target * easedProgress;

        number.textContent = this.formatNumber(value, decimals, useCommas);
      });

      if (progress < 1) {
        this.animationFrame = requestAnimationFrame(tick);
      } else {
        this.animationFrame = null;
      }
    };

    this.animationFrame = requestAnimationFrame(tick);
  }

  parseNumber(value) {
    return Number(String(value).replace(/,/g, "")) || 0;
  }

  formatNumber(value, decimals, useCommas) {
    const fixedValue = Number(value).toFixed(decimals);

    if (!useCommas) return fixedValue;

    const parts = fixedValue.split(".");
    parts[0] = Number(parts[0]).toLocaleString("en-US");

    return parts.join(".");
  }

  cancelAnimation() {
    if (!this.animationFrame) return;

    cancelAnimationFrame(this.animationFrame);
    this.animationFrame = null;
  }
}

function initElStatsShowcase(scope = document) {
  scope.querySelectorAll(".el-stats-showcase").forEach((section) => {
    if (section.dataset.elStatsShowcaseInit === "true") return;

    section.dataset.elStatsShowcaseInit = "true";
    new ElStatsShowcase(section);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initElStatsShowcase();
});

document.addEventListener("shopify:section:load", (event) => {
  initElStatsShowcase(event.target);
});
